export default __webpack_public_path__ + "static/media/02AW1SEP66.d1f707b7.jpg";